package com.islamicmedia.shared.platform

actual class AnalyticsTracker actual constructor() {
    actual fun logEvent(name: String, params: Map<String, Any>) {
        // No-op on web
    }
}
